export default __webpack_public_path__ + "static/media/cloud_campaign.9b0d2f4d.png";